/**
 * Keep the bridge CLI process alive after isolated JS faults when possible.
 * Does not prevent SIGABRT from native crashes or OOM.
 */

import { logImmediate } from './log.js';

let installed = false;

export function installBridgeProcessResilience(): void {
  if (installed) return;
  installed = true;

  process.on('uncaughtException', (err) => {
    logImmediate(`[bridge] uncaughtException — continuing: ${err.stack ?? String(err)}`);
  });

  process.on('unhandledRejection', (reason) => {
    logImmediate(`[bridge] unhandledRejection — continuing: ${reason instanceof Error ? reason.stack : String(reason)}`);
  });
}
